"use client"

import { useState, useEffect } from "react"
import { Button } from "../../../components/ui/button"
import { FormAddFicha } from "./add-exercise-sheet"
import { AddTraining } from "./add-training"
import { ListExerciseSheets } from "./list-exercise-sheets"
import { convertParamsToJson, useCashfitParams } from "@/view/hooks/use-params"
import { useSearchParams } from "react-router-dom"
import { WorkoutList } from "./list-training"
import { ArrowLeft, Plus, ClipboardList } from "lucide-react"

export function ExerciseSheet() {
  const [view, setView] = useState("sheet-list")
  const [params] = useSearchParams()
  const { getParam, setParams } = useCashfitParams(convertParamsToJson(params))
  const sheetId = getParam("sheetId")
  const trainingId = getParam("traningId")

  // Set the initial view based on URL parameters
  useEffect(() => {
    if (trainingId) {
      setView("add-workout")
    } else if (sheetId && view === "sheet-list") {
      setView("workout-list")
    }
  }, [sheetId, trainingId, view])

  const changeView = (newView: string) => {
    setView(newView)
  }

  const navigateToSheetList = () => {
    setParams({ sheetId: "", traningId: "" })
    setView("sheet-list")
  }

  const navigateToWorkoutList = () => {
    // Keep the sheetId if it exists, but clear the trainingId
    if (sheetId) {
      setParams({ sheetId, traningId: "" })
    } else {
      setParams({ traningId: "" })
    }
    setView("workout-list")
  }

  const renderHeader = () => {
    // Determine where back button should go
    const handleBackClick = () => {
      if (view === "create-sheet") {
        navigateToSheetList()
      } else if (view === "add-workout") {
        navigateToWorkoutList()
      } else if (view === "workout-list" && sheetId) {
        navigateToSheetList()
      }
    }

    // Determine if back button should be shown
    const showBackButton = view === "create-sheet" || view === "add-workout" || (view === "workout-list" && sheetId)

    return (
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          {showBackButton && (
            <Button variant="ghost" size="icon" onClick={handleBackClick} aria-label="Back">
              <ArrowLeft className="h-5 w-5" />
            </Button>
          )}
          <h2 className="text-xl font-semibold">
            {view === "sheet-list" && "Fichas de Treino"}
            {view === "create-sheet" && (sheetId ? "Editar Ficha" : "Criar Nova Ficha")}
            {view === "workout-list" && (sheetId ? `Treinos da Ficha` : "Todos os Treinos")}
            {view === "add-workout" && (trainingId ? "Editar Treino" : "Adicionar Novo Treino")}
          </h2>

        </div>

        {/* Action buttons for main list views */}
        {view === "sheet-list" && (
          <div className="flex gap-2">
            <Button onClick={() => changeView("create-sheet")} className="bg-acelerafit-green-400 text-white">
              <Plus className="mr-2 h-4 w-4" />
              Nova Ficha
            </Button>
          </div>
        )}

        {view === "workout-list" && (
          <div className="flex gap-2">
            <Button
              onClick={() => {
                if (sheetId) {
                  setParams({ sheetId, traningId: "" })
                }
                changeView("add-workout")
              }}
              className="bg-acelerafit-green-400 text-white"
            >
              <Plus className="mr-2 h-4 w-4" />
              Novo Treino
            </Button>
            {!sheetId && (
              <Button variant="outline" onClick={() => navigateToSheetList()}>
                <ClipboardList className="mr-2 h-4 w-4" />
                Fichas
              </Button>
            )}
          </div>
        )}


      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4">
      {renderHeader()}

      {view === "sheet-list" && <ListExerciseSheets changeTab={changeView} />}
      {view === "create-sheet" && <FormAddFicha changeTab={changeView} />}
      {view === "workout-list" && <WorkoutList changeTab={changeView} />}
      {view === "add-workout" && <AddTraining changeTab={changeView} />}
    </div>
  )
}
